import { render, staticRenderFns } from "./selected-dashboard.vue?vue&type=template&id=27983785&scoped=true"
import script from "./selected-dashboard.vue?vue&type=script&lang=ts"
export * from "./selected-dashboard.vue?vue&type=script&lang=ts"
import style0 from "./selected-dashboard.vue?vue&type=style&index=0&id=27983785&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27983785",
  null
  
)

export default component.exports